module.exports = __webpack_public_path__ + "static/media/Logo-SMORLCCC-bco.66d1dab2.png";